module.exports = __webpack_public_path__ + "img/u29.89458809.svg";